module.exports = __webpack_public_path__ + "img/info.93c48521.png";